<app-modal *ngIf="chartData?.length > 0" [allowClose]="false" class="view-document-modal" header="Copy Chart" [(visible)]="modalVisible">
    <div class="attach-chart-modal-header">
    <div class="attach-chart-modal-member-info">
        Member Name: <span class="attach-chart-modal-member-name">{{ firstName }} {{ lastName }}</span>
    </div>
    <br />
    <div class="attach-chart-modal-instruction">
        {{ instructionMessage }}
    </div>
    </div>
    <div class="attach-chart-modal-grid">
        <app-server-grid [configuration]="attachChartGridConfiguration" [(request)]="request"
            [(selection)]="attachChartChaseGridSelection" [isLoadOnInit]="true">
        </app-server-grid>
    </div>
    <footer class="attach-chart-modal-footer">
        <app-button classes="medium" text="Copy Chart" (onClick)="copyChart()"
            [disabled]="!enableCopyChartActions"></app-button>
        <app-button classes="secondary medium" (onClick)="cancelAction()" text="Cancel"></app-button>
    </footer>
</app-modal>